module.exports = __webpack_public_path__ + "img/txmn-main-sm.11944e8e.jpg";